import { Flex, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from '../Section'
import { ScopeRestriction } from './ScopeRestriction'

export function Scope() {
  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <SectionTitle>
            <FormattedMessage id="admin/promotions.form.scope.title" />
          </SectionTitle>
          <Text tone="secondary">
            <FormattedMessage id="admin/promotions.form.scope.subtitle" />
          </Text>
        </Flex>
      </SectionHeader>
      <SectionContent fluid>
        <ScopeRestriction name="scope" />
      </SectionContent>
    </Section>
  )
}
